<script setup>
import {ref} from "vue";

const showAnswer = ref(false);
</script>
<template>
    <div class="w-full p-5 border-t border-b border-dashed border-slate-300 cursor-pointer"  @click="showAnswer = !showAnswer">
        <div class="w-full flex justify-between items-center" :class="{'mb-5': showAnswer}">
            <p class="font-sans font-medium text-white text-base lg:text-xl">
                <slot name="question"></slot>
            </p>
            <span>
                <img src="/assets/icons/faq-arrow.svg" alt="" :class="{'rotate-180': showAnswer}" class="transition-transform"/>
            </span>

        </div>
        <div v-if="showAnswer">
            <p  class="font-sans font-normal text-white text-base">
                <slot name="answer"></slot>
            </p>
        </div>
    </div>

</template>
